import React from 'react';
import FlipCardSide from './FlipCardSide';
import { getElementBox } from '../../utils/animations';
import { TweenLite, Back } from 'gsap';
import classNames from 'classnames';
import './styles.styl';

const FlipCard = ({
  onClick,
  data,
  index,
  flipping,
  lockCard,
  unlockCard,
  seen
}) => {
  let card = null;

  const tweenCard = e => {
    if (flipping) return;
    const cardBox = getElementBox(card);
    const flipRight = e.clientX - cardBox.left > cardBox.width / 2;
    onClick(index);

    lockCard(index);

    TweenLite.to(card.childNodes, 1.75, {
      rotationY: flipRight ? '+=180' : '-=180',
      ease: Back.easeOut.config(1.75),
      onComplete: () => {
        unlockCard(index);
      }
    });
  };

  const handleCardClick = e => {
    tweenCard(e);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleCardClick(e);
    }
  };

  const cardClasses = () => {
    return classNames(
      'comet-card comet-card--white modal-cards__card flip-card'
    );
  };

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div
      className={cardClasses()}
      onClick={handleCardClick}
      onKeyPress={handleKeyDown}
      ref={c => {
        card = c;
      }}
      tabIndex={index + 1}
    >
      <FlipCardSide data={data.frontOfCard} seen={seen} />
      <FlipCardSide back={true} data={data.backOfCard} />
    </div>
  );
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

export default FlipCard;



// WEBPACK FOOTER //
// ../core/src/components/FlipCards/FlipCard.js